import { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import Link from 'next/link'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'

import { Layout } from '../../components/front'
import { useUser } from '../../components/front/User'

import { getProductCategories, getStaticDate } from '../../lib'

export async function getServerSideProps() {
    const hier = await getProductCategories()
    const data = await getStaticDate()

    return { props: { productCategories: hier, footer: data['about_footer'].content } }
}

const schema = yup.object().shape({
    username: yup.string().required('شماره موبایل خود را وارد کنید'),
    password: yup.string().required('رمز عبور خود را وارد کنید')
})

export default function Signin({ productCategories, footer }) {
    const user = useUser()
    const [activationSuccess, setActivationSuccess] = useState(false)
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search)
        setActivationSuccess(urlParams.get('activation') === 'success')
    }, [])

    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(schema)
    })

    const [errorMsg, setErrorMsg] = useState('')
    const router = useRouter()

    async function onSubmit(data) {
        if (errorMsg) setErrorMsg('')

        try {
            const response = await fetch('/api/auth/signin', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    username: data.username,
                    password: data.password
                })
            })
            let responseObject = await response.json()
            if (response.status === 200) {
                user.login(responseObject)
                const urlParams = new URLSearchParams(window.location.search)
                if (/^\/.+/.test(urlParams.get('returnUrl'))) router.push(urlParams.get('returnUrl'))
                else router.push(responseObject.returnUrl)
            } else {
                setErrorMsg(responseObject.message)
            }
        } catch (error) {
            console.error('An unexpected error happened occurred:', error)
            setErrorMsg(error.message)
        }
    }

    return (
        <Layout menu={productCategories} footer={{ about: footer }}>
            <section className="bg-gray-200 py-12">
                <div className="container mx-auto">
                    <div className="flex justify-center px-6">
                        <div className="w-full xl:w-3/4 lg:w-11/12 flex">
                            <div className="w-full lg:w-7/12 bg-white p-5 rounded-lg lg:rounded-l-none">
                                <h3 className="pt-4 text-2xl text-center mb-6 text-purple-400">
                                    اگر هنوز ثبت نام نکرده اید ابتدا ثبت نام کنید
                                </h3>
                                <div className="lg:px-24 pt-6 pb-4 mb-4 flex justify-center">
                                    <Link href="/auth/register">
                                        <button
                                            className="w-1/2 px-4 py-2 font-bold text-white bg-pink-300 rounded-lg hover:bg-pink-400 focus:outline-none focus:shadow-outline"
                                            type="submit"
                                        >
                                            ثبت نام کنید
                                        </button>
                                    </Link>
                                </div>
                                <hr className="mb-6 border-t" />

                                <h3 className="pt-4 text-2xl text-center mb-6 text-purple-400">
                                    وارد حساب کاربری خود شوید
                                </h3>
                                {activationSuccess && (
                                    <p className="lg:px-24 text-center text-green-500">
                                        حساب کاربری شما فعال شد اکنون میتوانید وارد شوید
                                    </p>
                                )}
                                <form
                                    className="lg:px-24 pt-6 pb-8 mb-4 bg-white rounded"
                                    onSubmit={handleSubmit(onSubmit)}
                                >
                                    <div className="mb-4">
                                        <label
                                            className="block mb-2 text-sm font-bold text-gray-700"
                                            htmlFor="username"
                                        >
                                            شماره موبایل
                                        </label>
                                        <input
                                            className="w-full text-end px-3 py-2 mb-3 text-sm leading-tight rounded-md border border-gray-200 shadow-sm focus:outline-none focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                                            name="username"
                                            autoComplete="username"
                                            type="tel"
                                            placeholder="موبایل"
                                            {...register('username')}
                                        />
                                        {errors?.username?.message}
                                    </div>
                                    <div className="mb-4">
                                        <label
                                            className="block mb-2 text-sm font-bold text-gray-700"
                                            htmlFor="password"
                                        >
                                            گذرواژه
                                        </label>
                                        <input
                                            className="w-full text-end px-3 py-2 mb-3 text-sm leading-tight rounded-md border border-gray-200 shadow-sm focus:outline-none focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                                            name="password"
                                            autoComplete="current-password"
                                            type="password"
                                            placeholder="گذرواژه"
                                            {...register('password')}
                                        />
                                        {errors?.password?.message}
                                    </div>
                                    <div className="mb-6 text-center">
                                        <button
                                            className="w-full px-4 py-2 font-bold text-white bg-purple-400 rounded-lg hover:bg-pink-400 focus:outline-none focus:shadow-outline"
                                            type="submit"
                                        >
                                            ورود
                                        </button>
                                        {errorMsg && <p className="text-red-500 mt-5">{errorMsg}</p>}
                                    </div>
                                    <hr className="mb-6 border-t" />
                                    <div className="text-center">
                                        <Link href="/auth/forget">
                                            <a className="inline-block text-sm text-blue-500 align-baseline hover:text-blue-800">
                                                گذرواژه خود را فراموش کرده ام
                                            </a>
                                        </Link>
                                    </div>
                                </form>
                            </div>

                            <div
                                className="w-full h-auto bg-gray-400 hidden lg:block lg:w-5/12 bg-cover rounded-l-lg py-10"
                                style={{
                                    backgroundColor: 'white'
                                }}
                            >
                                <img src="/img/login.gif" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    )
}
